import { Tooltip, message as toast } from "antd";
import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import styles from "./index.module.less";
import IconFont from "@/components/icon";
import { AI_CHAT_PREDICT, ChatMessage } from "@/types/chat";
import { connect } from "dvajs";
import { getMessageDetectRole } from "@/utils/chat/message";
import { getForwardMessageSummary } from "@/api/llm";
import ImService from "@/server/ImService";
import { changeEgovUrl } from "@/utils/tools";
import { isArray } from "lodash";
import { addXclient } from "@/utils/addToken";
import { getFileUrl } from "@/utils/chat/index";

// 转发摘要
function AIForwardMsgSummery(props: any) {
  const { message, currentEmployee, detail = false, updateSessionMessageMid } = props;
  const rawMessagesRef = useRef<any[]>(message?.intentData?.messages || []);
  const initRef = useRef<boolean>(false);
  const [open, setOpen] = useState<boolean>(!!detail || !!message?.intentData?.summary);
  const intentSummary = useMemo(() => {
    return message?.intentData?.summary || "";
  }, [message.intentData?.summary]);

  const intentHighlight = useMemo(() => {
    if (message?.intentData?.highlight && isArray(message?.intentData?.highlight)) {
      return (
        <div className={styles["highlight-wrap"]}>
          {message?.intentData?.highlight?.map((item: any, idx: number) => {
            return (
              <div
                key={`${message.id}_hightlight-${idx}`}
                className={styles["item"]}
              >{`${item.name}:${item.content}`}</div>
            );
          })}
        </div>
      );
    } else {
      return <div />;
    }
  }, [message?.intentData?.highlight]);

  const getMessages = useCallback(async () => {
    if (rawMessagesRef.current?.length) {
      return rawMessagesRef.current;
    }
    const url = message?.data?.[0]?.content || "";
    if (!url) {
      return [];
    }
    const rawLink = await addXclient(getFileUrl(url));
    const imService = ImService.getInstance();
    const result: any = await imService.getMergeForwardBody(
      changeEgovUrl(message.data[0].content),
      message.id
    );
    return {
      messageUrl: rawLink,
      res: result?.messages || []
    };
  }, [message?.data, message?.id]);

  const handleGetSummary = useCallback(() => {
    getMessages().then((data: any) => {
      const { res, messageUrl = "" } = data;
      if (!res?.length) {
        return;
      }
      getForwardMessageSummary({
        messages: res.map((m: any) => {
          return {
            userId: m.sender,
            content: m.content,
            userName: m.senderName
          };
        }),
        role: getMessageDetectRole({
          message,
          currentEmployee
        }),
        msgUuid: message.id,
        messageUrl
      }).then((sum: any) => {
        message.intentData = {
          messages: res,
          summary: sum.text || "暂无摘要",
          highlight: isArray(sum?.highlight) ? sum?.highlight : [],
          predictType: AI_CHAT_PREDICT.FORWARD_MESSAGE_SUMMARY
        };
        updateSessionMessageMid({
          sendResult: {
            body: message
          },
          sessionId: message.sessionId,
          saveLocal: true
        });
        setOpen(true);
      });
    });
  }, [currentEmployee, getMessages, message, updateSessionMessageMid]);

  const handleOpen = useCallback(
    (e: any) => {
      if (detail) {
        return;
      }
      e?.stopPropagation();
      setOpen(!open);
    },
    [open, detail]
  );
  useEffect(() => {
    if (!message?.intentData && !initRef.current) {
      // 请求
      initRef.current = true;
      handleGetSummary();
    }
  }, [handleGetSummary, message?.intentData]);

  return (
    <div
      className={`${styles["ai-forward-summary-wrap"]} ${open ? styles["open"] : ""} ${
        detail ? styles["detail"] : ""
      }`}
    >
      <div
        className={styles["title-wrap"]}
        onClick={handleOpen}
        clstag="pageclick|keycount|Xtbg_Msg_MergeForward_More"
      >
        <div className={styles["left"]}>
          <span className={styles["icon"]} />
          <span className={styles["text"]}>智能总结</span>
        </div>
        {detail ? null : (
          <Tooltip title={open ? "收起" : "展开"}>
            <IconFont
              type={open ? "iconbtn_top_down" : "iconbtn_top_up"}
              className={styles["btn-open"]}
            />
          </Tooltip>
        )}
      </div>
      <div className={styles["summary-content-wrap"]}>
        {intentHighlight}
        <Tooltip title={detail ? "" : intentSummary}>
          <div
            className={styles["summary-content"]}
            dangerouslySetInnerHTML={{ __html: intentSummary }}
          />
      </Tooltip>
      </div>
    </div>
  );
}
function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee,
    llmSetting: chat.llmSetting
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    },
    updateSessionMessageMid(data: { sendResult: any; sessionId: string; saveLocal?: string }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AIForwardMsgSummery);
